import jwt from 'jsonwebtoken'

const TOKEN = 't'
const PERMISSIONS = 'p'

export function saveToken(token) {
  localStorage.setItem(TOKEN, token)
}

export function getToken() {
  return localStorage.getItem(TOKEN)
}

export function removeToken() {
  localStorage.removeItem(TOKEN)
}

export function getEmpresas() {
  try {
    const payload = _getPayload()
    return payload.companies ? payload.companies : []
  } catch (error) {
    return []
  }
}

export function getTipoArquivosImportacaoPorEmpresa(empresaId) {
  try {
    const payload = _getPayload()
    const empresas = payload.companies
    const empresa = empresas.find(e => e.id === empresaId)
    return empresa ? empresa.importation_file_types : []
  } catch (error) {
    return []
  }
}

export function getCentraisOperacoes() {
  try {
    const payload = _getPayload()
    return payload.operationsCenters
  } catch (error) {
    return []
  }
}

export function getTps(addTodos = true) {
  try {
    const payload = _getPayload()
    const { tps } = payload
    if (tps.length > 1 && addTodos) {
      tps.unshift({
        id: 0,
        name: 'Todos',
      })
    }
    return tps
  } catch (error) {
    return []
  }
}

export function getUsuarioInfo() {
  try {
    const payload = _getPayload()
    const { id, name, email } = payload
    return { id, name, email }
  } catch (error) {
    return { id: null, name: '', email: '' }
  }
}

export function isTokenExpirado() {
  try {
    const payload = _getPayload()
    //exp is in SECOND
    const { exp } = payload
    return new Date().getTime() > exp * 1000
  } catch (error) {
    return true
  }
}

export function getPermissions() {
  try {
    const payload = _getPayload()
    return payload[PERMISSIONS]
  } catch (error) {
    return []
  }
}

export function getTpPermissions(tpId) {
  try {
    const payload = _getPayload()
    const permissions = new Set()
    payload.tps.forEach(tp => {
      if (tpId === 0) {
        tp.permissions.forEach(permission => permissions.add(permission))
        return
      }
      if (tp.id === tpId) {
        tp.permissions.forEach(permission => permissions.add(permission))
      }
    })

    return Array.from(permissions)
  } catch (error) {
    return []
  }
}

function _getPayload() {
  const token = localStorage.getItem(TOKEN)
  if (!token) return null
  const decoded = jwt.decode(token, { complete: true })
  return decoded.payload
}
